import React, { useEffect, useState } from 'react';

import ErroriEmail from './ErroriEmail';
import ErroriIsee from './ErroriIsee';
import ErroriProtocollo from './ErroriProtocollo';
import { BandoService } from '../../../services/BandoService';

const ErroriMassivi = () => {

  const [activeTab, setActiveTab] = useState('tab-1');

  const [avvisi, setAvvisi] = useState(null);

  const bandoService = new BandoService();

  const tabItems = [
    {
      id: 'tab-1',
      label: 'Protocollo',
      content: <ErroriProtocollo
                 avvisi={avvisi}
               />,
    },
    {
      id: 'tab-2',
      label: 'Isee',
      content: <ErroriIsee
                avvisi={avvisi}
               />,
    },
    {
      id: 'tab-3',
      label: 'Email',
      content:<ErroriEmail
                avvisi={avvisi}
              />
    },
  ];

  useEffect(() => {
    bandoService.getAll().then((resp) => {
      setAvvisi(resp);
    });
  }, []);

  return (
    <div className='rtds-container rtds-py-6'>
      <div className='rtds-grid rtds-gap-6 xl:rtds-gap-8'>
        <div className='rtds-flex rtds-items-center rtds-justify-between'>
          <h1 className='rtds-heading-2'>Gestione errori</h1>
        </div>
        <div>
          <h2 className="rtds-sr-only" id="tablist-1">Titolo tablist</h2>
          <ul
            role="tablist"
            aria-labelledby="tablist-1"
            className="rtds-tablist is-tablist is-manual rtds-border-b rtds-border-gray-01 rtds-mb-4 md:rtds-mb-10 rtds-flex"
          >
            {tabItems.map((tab) => (
              <li role="presentation" key={tab.id}>
                <button
                  className={`rtds-tab is-tab rtds-tab--default rtds-flex rtds-p-2 md:rtds-p-3 rtds-border-b-2 rtds-border-transparent rtds-text-sm md:rtds-text-base rtds-content-01 hover:rtds-background-02 rtds-transition-all
                    ${activeTab === tab.id ? 'rtds-border-gray-04 rtds-font-bold rtds-text-primary' : ''}`}
                  role="tab"
                  id={tab.id}
                  aria-selected={activeTab === tab.id}
                  aria-controls={`tabpanel-${tab.id.split('-')[1]}`}
                  tabIndex={activeTab === tab.id ? 0 : -1}
                  onClick={() => setActiveTab(tab.id)}
                >
                  <span>{tab.label}</span>
                </button>
              </li>
            ))}
          </ul>

          {tabItems.map((tab) => (
            <div
              key={tab.id}
              id={`tabpanel-${tab.id.split('-')[1]}`}
              className={`rtds-tablist__tabpanel ${activeTab === tab.id ? '' : 'hidden'}`}
              role="tabpanel"
              aria-labelledby={tab.id}
            >
              {tab.content}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ErroriMassivi;